import * as universal from '../entries/pages/blog/_slug_/_page.ts.js';
import stylesheet_5 from '../stylesheets/5.js';
import stylesheet_6 from '../stylesheets/6.js';

export const index = 6;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/blog/_slug_/_page.svelte.js')).default;
export { universal };
export const universal_id = "src/routes/blog/[slug]/+page.ts";
export const imports = ["_app/immutable/nodes/6.1a9b45ce.js","_app/immutable/chunks/BlogContentCard.05febddf.js","_app/immutable/chunks/control.f5b05b5f.js","_app/immutable/chunks/scheduler.2887eafe.js","_app/immutable/chunks/index.387b3ba3.js","_app/immutable/chunks/each.77017db3.js"];
export const stylesheets = ["_app/immutable/assets/6.f3e669b7.css","_app/immutable/assets/BlogContentCard.ad128bc8.css"];
export const fonts = [];
export const inline_styles = () => ({
	"_app/immutable/assets/6.f3e669b7.css": stylesheet_5,
	"_app/immutable/assets/BlogContentCard.ad128bc8.css": stylesheet_6
});
